import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import OkCancelModal from '../../shared/components/OkCancelModal';
import messages from './documentMessages';
import RelationSearch from '@/shared/components/input/RelationSearch';
import authService from '@/shared/services/AuthService';

export default class LinkRelationDocumentModal extends Component {
  state = {
    selectedRelation: undefined,
  };

  relationChanged(relation) {
    if (!relation) return;

    this.setState(state => ({
      ...state,
      selectedRelation: relation.key,
    }));
  }

  linkDocumentToRelation() {
    const { selectedRelation } = this.state;
    const { onSave, document } = this.props;

    if (!selectedRelation) return; // TOdO add error

    const relationDocument = {
      ...document,
      documentId: document.id,
      relationId: selectedRelation,
    };

    return onSave(relationDocument);
  }

  render() {
    const { show, onClose, document, onSave, intl } = this.props;
    const { selectedRelation } = this.state;
    const disabled = !authService.hasPermission({
      functionality: 'Documents',
      privilege: 'Update',
    });

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.LinkToRelation)}
        show={show}
        onClose={onClose}
        disabled={!selectedRelation || disabled}
        onSave={() => this.linkDocumentToRelation()}
      >
        {show && (
          <div>
            <p>
              <FormattedMessage
                {...messages.ChooseRelationLinkDocument}
                values={{ documentName: `${document.name}` }}
              />
            </p>

            <RelationSearch onChange={relation => this.relationChanged(relation)} />
          </div>
        )}
      </OkCancelModal>
    );
  }
}
